const DluchReportingApi = function (ApiRequestedPath, id = '') {
  const apiEnvironment = function () {
    let env;

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      env = 'development';
    } else if (process.env.JEST_WORKER_ID !== undefined) {
      env = 'test';
    } else {
      env = 'production';
    }

    return env;
  };

  this.requestPath = function () {
    let path;

    switch (ApiRequestedPath) {
      case 'ReportIndex':
        path = '/api/reports';
        break;
      default:
        path = '';
    }

    return path;
  };

  this.ApiRequestUrl = function () {
      return this.requestHostname + this.requestPath();
  };

  this.requestHostname = process.env.REACT_APP_REPORTING_API_ENDPOINT ?? 
    'https://localhost:7071';
  this.ApiEnvironment = apiEnvironment();
};

export default DluchReportingApi;
